import { render, staticRenderFns } from "./SchemePension.vue?vue&type=template&id=f0b70d92&scoped=true&"
import script from "./SchemePension.vue?vue&type=script&lang=js&"
export * from "./SchemePension.vue?vue&type=script&lang=js&"
import style0 from "./SchemePension.vue?vue&type=style&index=0&id=f0b70d92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b70d92",
  null
  
)

export default component.exports